import React from "react";
import { Check, Loader2, WifiOff, AlertTriangle } from "lucide-react";

// status: idle | saving | saved | offline | error
export function StatusPill({ status }) {
  const map = {
    idle: { text: "", cls: "", icon: null },
    saving: { text: "Saving\u2026", cls: "text-inkfaint", icon: <Loader2 className="w-3.5 h-3.5 animate-spin" /> },
    saved: { text: "Saved", cls: "text-emsuccess", icon: <Check className="w-3.5 h-3.5" /> },
    offline: { text: "Offline \u2014 draft protected", cls: "text-emwarning", icon: <WifiOff className="w-3.5 h-3.5" /> },
    error: { text: "Save failed \u2014 your draft is protected", cls: "text-emwarning", icon: <AlertTriangle className="w-3.5 h-3.5" /> },
  };
  const s = map[status] || map.idle;
  if (!s.text) return <span className="h-5" data-testid="save-status" />;
  return (
    <span className={`inline-flex items-center gap-1.5 text-xs ${s.cls}`} data-testid="save-status" data-status={status}>
      {s.icon}{s.text}
    </span>
  );
}
